module Shared {
    export enum PublicSectorAssignmentCheckButtonPressed {
        public = 0,
        private = 1,
        notrequired = 2
    }
}